import { logInfo } from '@seo/logger';

export interface LogInfo {
    type: string,
    log: string,
    source?: string,
    brand?: string,
    debug?: string,
    facetQueryArray?: Array<string>
    facetQueryString?: string
    referrer?: string,
    requestId?: string,
    theme?: string,
    url?: string
}

export interface NewRelicInfo extends LogInfo {
    eventName?: string
}

const logThematicInfo = (infoObj: LogInfo) => {
  const newRelicObject: NewRelicInfo = {
    eventName: 'thematicInfo',
    ...infoObj,
  };

  logInfo(infoObj, newRelicObject);
};

export default logThematicInfo;
